import { Bot, Lightbulb, AlertCircle } from 'lucide-react';

const VARIANTS = {
  auto: {
    label: 'Automatisch ingesteld',
    className: 'bg-neutral-100 text-neutral-600 border-neutral-200',
    Icon: Bot,
  },
  recommended: {
    label: 'Aanbevolen',
    className: 'bg-blue-50 text-blue-700 border-blue-200',
    Icon: Lightbulb,
  },
  required: {
    label: 'Actie vereist',
    className: 'bg-amber-50 text-amber-700 border-amber-200',
    Icon: AlertCircle,
  },
};

const DecisionBadge = ({ type = 'auto', className = '' }) => {
  const variant = VARIANTS[type] || VARIANTS.auto;
  const { Icon } = variant;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold border ${variant.className} ${className}`}
      data-testid={`decision-badge-${type}`}
    >
      <Icon className="h-3 w-3" strokeWidth={2} />
      {variant.label}
    </span>
  );
};

export default DecisionBadge;
export { VARIANTS };
